class MapHelper{

	static inPlaceSort(map, sort){
		const sorted = Array.from(map).sort(sort);
		map.clear();
		for(let [key, value] of sorted){
			map.set(key, value);
		}
		return map;
	}
}

export {MapHelper}